import * as React from "react";
import {IconProps} from "./IconProps";

export const IconDoubleRightChevron = React.forwardRef<SVGSVGElement, IconProps>(
    ({color = "currentColor", ...props}, forwardedRef) => {
        return (
            <svg
                width="20" height="20" viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
                ref={forwardedRef}
            >
                <path
                    d="M5.24408 6.07733C5.56951 5.75189 6.09715 5.75189 6.42259 6.07733L9.75592 9.41066C10.0814 9.7361 10.0814 10.2637 9.75592 10.5892L6.42259 13.9225C6.09715 14.2479 5.56951 14.2479 5.24408 13.9225C4.91864 13.5971 4.91864 13.0694 5.24408 12.744L7.98816 9.99992L5.24408 7.25584C4.91864 6.9304 4.91864 6.40277 5.24408 6.07733ZM11.0774 6.07733C11.4028 5.75189 11.9305 5.75189 12.2559 6.07733L15.5893 9.41066C15.9147 9.7361 15.9147 10.2637 15.5893 10.5892L12.2559 13.9225C11.9305 14.2479 11.4028 14.2479 11.0774 13.9225C10.752 13.5971 10.752 13.0694 11.0774 12.744L13.8215 9.99992L11.0774 7.25584C10.752 6.9304 10.752 6.40277 11.0774 6.07733Z"
                    fill={color}/>

            </svg>
        );
    },
);
